import OrganizationEngagementViewChartFigure from './OrganizationEngagementViewChartFigure';

export default OrganizationEngagementViewChartFigure;
